import React from 'react';
import styled from 'styled-components';
import ComponentWrapper from '../layout/ComponentWrapper';
import ResourceItem from './ResourceItem';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';

const Wrapper = styled.div` 
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${({type}) => type === "asco" ? "30px 20px" : "25px 20px"};
     ${({type}) => type === "asco" ? `
    @media (max-width: ${NAVIGATION_BREAKPOINT}) {
        grid-template-columns:  1fr;
        gap: 15px;
    }`: ``}
`;

const ResourceLibrary = props => {

    return (
        <ComponentWrapper>
            <Wrapper type={props.type}>
                {props.items.map((item) => {
                    return (
                        <ResourceItem type={props.type} {...item} allResourcesDisabled={props.allResourcesDisabled} />
                    );
                })}
            </Wrapper>   
        </ComponentWrapper>
    );
};

export default ResourceLibrary;
